import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';

import { TacoAlimento } from '../../../../../models/TacoAlimento';
import { PlanoAlimentarService } from '../../../../../services/plano-alimentar/plano-alimentar.service';
import { getPaginatorIntl } from '../../../../../shared/mat-paginator-intl';

@Component({
  selector: 'app-pesquisa-alimentos-taco',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatTableModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
  ],
  templateUrl: './pesquisa-alimentos-taco.html',
  styleUrl: './pesquisa-alimentos-taco.scss',
  providers: [{ provide: MatPaginatorIntl, useFactory: getPaginatorIntl }],
})
export class PesquisaAlimentosTaco implements OnInit {
  @ViewChild(MatSort) sort!: MatSort;

  alimentos = new MatTableDataSource<TacoAlimento>();
  public isLoading = true;

  displayedColumns: string[] = ['descricaoAlimento'];

  constructor(
    public dialogRef: MatDialogRef<PesquisaAlimentosTaco>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private planoAlimentarService: PlanoAlimentarService
  ) {}

  async ngOnInit() {
    try {
      const data = await this.planoAlimentarService.buscarAlimentosTaco();
      this.alimentos.data = data;
    } catch (error) {
      console.error('Erro ao carregar alimentos:', error);
    } finally {
      this.isLoading = false;
      this.alimentos.sort = this.sort;
    }
  }

  buscarPorNome(event: Event) {
    const normalizeString = (str: string) =>
      str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/ç/g, 'c')
        .toLowerCase()
        .trim()
        .replace(/,/g, '');

    const nomeDigitado = normalizeString((event.target as HTMLInputElement).value);

    this.alimentos.filterPredicate = (data: TacoAlimento, filter: string) => {
      const descricaoNormalizada = normalizeString(data.descricaoAlimento ?? '');
      return descricaoNormalizada.includes(filter);
    };

    this.alimentos.filter = nomeDigitado;
  }

  onSelect(alimento: TacoAlimento) {
    this.dialogRef.close(alimento);
  }
  inserirManualmente() {
    this.dialogRef.close("MANUAL");
  }
  onCancel() {
    this.dialogRef.close();
  }
}
